var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103); var defaultProps = type && type.defaultProps, childrenLength = arguments.length - 3; if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) { for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3]; props.children = childArray; } if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {}); return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import PropTypes from 'prop-types';
import AcChart from 'react-apexcharts';
import { NoData } from "../NoData/NoData";
import { useTheme } from '@material-ui/core/styles';
import { ChartWrapper } from "../ChartWrapper/ChartWrapper";
import { useAfterMountingValue } from "../../hooks/useAfterMountingValue";
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

var _ref2 = /*#__PURE__*/_jsx(NoData, {});

const CommonLinearChart = _ref => {
  let type = _ref.type,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      color = _ref.color,
      yTitle = _ref.yTitle,
      _ref$maxValuesInSight = _ref.maxValuesInSight,
      maxValuesInSight = _ref$maxValuesInSight === void 0 ? 10 : _ref$maxValuesInSight,
      _ref$barWidth = _ref.barWidth,
      barWidth = _ref$barWidth === void 0 ? 50 : _ref$barWidth,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  const theme = useTheme();
  const width = useAfterMountingValue('99%', '100%');
  const wrapperRef = useRef();

  const _useState = useState(),
        _useState2 = _slicedToArray(_useState, 2),
        wrapperWidth = _useState2[0],
        setWrapperWidth = _useState2[1];

  useEffect(() => {
    if (wrapperRef.current) {
      setWrapperWidth(wrapperRef.current.offsetWidth);
    }
  }, [values]);

  if (!values.length) {
    return _ref2;
  }

  const props = {
    type,
    width,
    height: '100%',
    series: [{
      name: yTitle,
      data: values.map(value => value.value)
    }],
    options: _.defaultsDeep(options, {
      grid: {
        show: !horizontal || type === 'line'
      },
      chart: {
        fontFamily: theme.typography.fontFamily,
        foreColor: theme.palette.text.primary,
        zoom: {
          enabled: true
        },
        events: {
          beforeResetZoom: () => ({
            xaxis: {
              max: maxValuesInSight
            }
          }),
          beforeZoom: (_, opt) => ({
            xaxis: {
              max: opt.xaxis.max > maxValuesInSight ? maxValuesInSight : opt.xaxis.max
            }
          })
        }
      },
      colors: [color || theme.palette.primary.main],
      plotOptions: {
        bar: {
          columnWidth: "".concat(Math.round(barWidth / (wrapperWidth / values.length) * 100), "%"),
          borderRadius: 5,
          horizontal
        },
        dataLabels: {
          position: 'top',
          maxItems: maxValuesInSight,
          hideOverflowingLabels: true
        }
      },
      tooltip: {
        x: {
          formatter: (_, _ref3) => {
            let dataPointIndex = _ref3.dataPointIndex;
            return values[dataPointIndex].label;
          }
        }
      },
      xaxis: {
        categories: values.map(value => value.label),
        max: maxValuesInSight,
        tickPlacement: 'on',
        labels: {
          rotate: 0,
          hideOverlappingLabels: false,
          style: Object.assign(theme.typography.caption, {
            fontWeight: 400
          })
        },
        tooltip: {
          enabled: false
        }
      },
      yaxis: {
        title: {
          text: yTitle,
          style: Object.assign(theme.typography.caption, {
            fontWeight: 400
          })
        },
        labels: {
          // formatter: (value) => value.toFixed(0),
          style: Object.assign(theme.typography.caption, {
            fontWeight: 400
          })
        }
      },
      dataLabels: {
        enabled: false
      }
    })
  };
  return _jsx(ChartWrapper, {
    wrapperRef: wrapperRef
  }, void 0, React.createElement(AcChart, props));
};

export { CommonLinearChart };